import React, { useState, useEffect } from "react";
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function CookiesSetting() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false,
    functionality: false,
    marketing: false,
  });

  // Load saved preferences on page load
  useEffect(() => {
    const saved = localStorage.getItem("cookiePreferences");
    if (saved) {
      setPreferences(JSON.parse(saved));
    }
  }, []);

  const handleToggle = (key) => {
    if (key === "essential") return; // cannot disable essential
    setPreferences((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const savePreferences = () => {
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    alert(t('cookiesSetting.messages.preferencesSaved'));
  };

  const acceptAll = () => {
    const allTrue = {
      essential: true,
      analytics: true,
      functionality: true,
      marketing: true,
    };
    setPreferences(allTrue);
    localStorage.setItem("cookiePreferences", JSON.stringify(allTrue));
    alert(t('cookiesSetting.messages.allAccepted'));
  };

  const rejectAll = () => {
    const onlyEssential = {
      essential: true,
      analytics: false,
      functionality: false,
      marketing: false,
    };
    setPreferences(onlyEssential);
    localStorage.setItem("cookiePreferences", JSON.stringify(onlyEssential));
    alert(t('cookiesSetting.messages.allRejected'));
  };

  return (
    <div className="r4l-cookie-settings">
      <h1>
        {t('cookiesSetting.title')}
      </h1>
      <p dangerouslySetInnerHTML={{ __html: t('cookiesSetting.description') }} />

      <div className="r4l-cookie-list">
        {[
          { key: "essential", label: t('cookiesSetting.cookieTypes.essential') },
          { key: "analytics", label: t('cookiesSetting.cookieTypes.analytics') },
          { key: "functionality", label: t('cookiesSetting.cookieTypes.functionality') },
          { key: "marketing", label: t('cookiesSetting.cookieTypes.marketing') },
        ].map(({ key, label }) => (
          <label key={key}>
            <span>{label}</span>
            <input
              type="checkbox"
              checked={preferences[key]}
              onChange={() => handleToggle(key)}
              disabled={key === "essential"}
            />
          </label>
        ))}
      </div>

      <div className="r4l-cookie-actions">
        <button type="button" className="r4l-btn-line" onClick={rejectAll}>
          {t('cookiesSetting.buttons.reject')}
        </button>
        <button type="button" className="r4l-btn-line" onClick={savePreferences}>
          {t('cookiesSetting.buttons.savePreferences')}
        </button>
        <button type="button" className="r4l-btn" onClick={acceptAll}>
          {t('cookiesSetting.buttons.acceptAll')}
        </button>
      </div>
    </div>
  );
}

export default CookiesSetting;
